import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { Device, DeviceInfo } from '@capacitor/device';

@Injectable({ providedIn: 'root' })
export class DeviceService {
  private deviceName = '';

  public getDevice(): string {
    return this.deviceName;
  }

  public fetch(): Promise<string> {
    if (this.deviceName) {
      return Promise.resolve(this.deviceName);
    }
    return Device.getInfo().then((info: DeviceInfo) => (this.deviceName = this.getFormatedDevice(info)));
  }

  public getFormatedDevice(device: DeviceInfo): string {
    if (Capacitor.isNativePlatform()) {
      const deviceName = [device.manufacturer, device.model].join(' ').trim();
      let os = [device.platform, device.osVersion].join(' ').trim();
      if (os) {
        os = `(${os})`;
      }
      return [deviceName, os].join(' ').trim();
    } else {
      return 'Browser';
    }
  }
}
